import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import useSWR from 'swr';
import { EventWithData } from '../../../../../../../typings/Event.interface';
import { EventAttempt } from '../../../../../../../typings/EventAttempt.interface';
import { DeliveryIssueWithData } from '../../../../../../../typings/Issue.interface';
import { Transformation } from '../../../../../../../typings/Transformation.interface';
import { APIWebhook } from '../../../../../../../typings/Webhook.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { EventListFiltersProps } from '../../../../typings/EventList.interface';
import { stringifyQuery } from '../../../../utils';
import { RelativeDate } from '../../../../utils/date';
import Button from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Link from '../../../common/base/Link';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { BodyCollapsibleSection } from '../../../common/Data/Body';
import Switch from '../../../common/Form/Fields/Switch';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DashboardContext } from '../DashboardContext';
import { EventHTTPRequest } from '../Event/EventHTTPRequest';
import Histogram from '../Events/Histogram';
import { APIDestination } from '../../../../../../../typings/Destination.interface';
import { BulkOperationProgress } from '../../../common/BulkOperations';
const DeliveryIssue: React.FC<{
  issue: DeliveryIssueWithData;
  render_data: {
    webhooks_by_id: APIWebhook[];
    transformations_by_id: Transformation[];
    destinations_by_id: APIDestination[];
  };
  setDate: (query_date: object) => void;
  start_date: Date;
  end_date: Date;
  relative_date?: RelativeDate;
  refresh_key: string;
}> = t0 => {
  const $ = _c(85);
  const {
    issue,
    start_date,
    end_date,
    setDate,
    relative_date,
    refresh_key
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    subscription,
    organization
  } = useContext(DashboardContext);
  const [tab, setTab] = useState("request");
  const [currently_matching_only, setMatchingOnly] = useState(false);
  let t1;
  if ($[0] !== issue.data.trigger_event) {
    t1 = issue.data.trigger_event ?? {} as EventWithData;
    $[0] = issue.data.trigger_event;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trigger_event = t1;
  let t2;
  if ($[2] !== issue.data.trigger_attempt) {
    t2 = issue.data.trigger_attempt ?? {} as EventAttempt;
    $[2] = issue.data.trigger_attempt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const trigger_attempt = t2;
  const t3 = issue.id;
  let t4;
  if ($[4] !== start_date) {
    t4 = start_date.toISOString();
    $[4] = start_date;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== end_date) {
    t5 = end_date.toISOString();
    $[6] = end_date;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== relative_date || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      relative: relative_date,
      min: t4,
      max: t5
    };
    $[8] = relative_date;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== issue.id || $[13] !== t6) {
    t7 = {
      issue_id: t3,
      date: t6
    };
    $[12] = issue.id;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let filters = t7 as EventListFiltersProps;
  if (currently_matching_only) {
    const t8 = issue.aggregation_keys;
    let t9;
    if ($[15] !== issue.aggregation_keys.response_status) {
      t9 = issue.aggregation_keys.response_status.map(_temp);
      $[15] = issue.aggregation_keys.response_status;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== filters || $[18] !== issue.aggregation_keys || $[19] !== t9) {
      t10 = {
        ...t8,
        response_status: t9,
        ...filters
      };
      $[17] = filters;
      $[18] = issue.aggregation_keys;
      $[19] = t9;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    filters = t10;
  }
  let t8;
  if ($[21] !== issue.id) {
    t8 = APIMethodKeys.bulk.events.list({
      query: {
        issue_id: issue.id
      },
      query_partial_match: true,
      in_progress: true
    });
    $[21] = issue.id;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== HookdeckAPI.bulk.events || $[24] !== issue.id) {
    t9 = () => HookdeckAPI.bulk.events.list({
      query: {
        issue_id: issue.id
      },
      query_partial_match: true,
      in_progress: true
    });
    $[23] = HookdeckAPI.bulk.events;
    $[24] = issue.id;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      refreshInterval: 5000
    };
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const {
    data: current_bulk_retries
  } = useSWR(t8, t9, t10);
  const current_bulk_retry = current_bulk_retries?.models && current_bulk_retries.models.length > 0 && current_bulk_retries.models[0];
  let t11;
  if ($[27] !== current_bulk_retry) {
    t11 = current_bulk_retry && <StyledCard m={{
      b: 8
    }}><StyledCardSection p={{
        x: 4,
        y: 3
      }}><Text semi={true}>Bulk retry in progress</Text></StyledCardSection><StyledCardSection p={4}><BulkOperationProgress operation_type="retry" model="events" operation={current_bulk_retry} /></StyledCardSection></StyledCard>;
    $[27] = current_bulk_retry;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text bold={true} size="l" m={{
      b: 4
    }}>Event histogram</Text>;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      x: 4,
      y: 3
    };
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== end_date || $[32] !== filters || $[33] !== refresh_key || $[34] !== setDate || $[35] !== start_date) {
    t14 = <StyledCardSection p={t13}><Histogram model="Events" dimention="status" filters={filters} start_date={start_date} end_date={end_date} setDate={setDate} allow_reset={false} refresh_key={refresh_key} show_date_filter={true} /></StyledCardSection>;
    $[31] = end_date;
    $[32] = filters;
    $[33] = refresh_key;
    $[34] = setDate;
    $[35] = start_date;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      y: 3,
      x: 4
    };
    t16 = {
      justify: "space-between",
      align: "center"
    };
    $[37] = t15;
    $[38] = t16;
  } else {
    t15 = $[37];
    t16 = $[38];
  }
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      gap: 2
    };
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== currently_matching_only) {
    t18 = () => setMatchingOnly(!currently_matching_only);
    $[40] = currently_matching_only;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== currently_matching_only || $[43] !== t18) {
    t19 = <Switch checked={currently_matching_only} onChange={t18} />;
    $[42] = currently_matching_only;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text muted={true}>Only display failed events still matching the issue</Text>;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t19) {
    t21 = <Div flex={t17}>{t19}{t20}</Div>;
    $[46] = t19;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== currently_matching_only || $[49] !== end_date || $[50] !== issue.aggregation_keys || $[51] !== issue.id || $[52] !== start_date) {
    t22 = stringifyQuery({
      issue_id: issue.id,
      date: {
        max: end_date.toISOString(),
        min: start_date.toISOString()
      },
      ...(currently_matching_only ? {
        response: {
          response_status: issue.aggregation_keys.response_status?.length === 1 ? {
            min: issue.aggregation_keys.response_status[0],
            max: issue.aggregation_keys.response_status[0]
          } : undefined,
          error_code: issue.aggregation_keys.response_status?.length > 0 ? issue.aggregation_keys.error_code : undefined
        }
      } : {})
    });
    $[48] = currently_matching_only;
    $[49] = end_date;
    $[50] = issue.aggregation_keys;
    $[51] = issue.id;
    $[52] = start_date;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  const t23 = `/events?${t22}`;
  let t24;
  if ($[54] !== t23) {
    t24 = <Button icon="link" outline={true} to={t23}>View events</Button>;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t21 || $[57] !== t24) {
    t25 = <StyledCardSection p={t15} flex={t16}>{t21}{t24}</StyledCardSection>;
    $[56] = t21;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t14 || $[60] !== t25) {
    t26 = <StyledCard>{t14}{t25}</StyledCard>;
    $[59] = t14;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Text size="l" bold={true} m={{
      b: 4,
      t: 10
    }}>Sample Event Data</Text>;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      b: 6
    };
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  let t30;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = tab_0 => setTab(tab_0 as 'request' | 'response');
    t30 = [{
      label: "Request",
      key: "request"
    }, {
      label: "Response",
      key: "response"
    }];
    $[64] = t29;
    $[65] = t30;
  } else {
    t29 = $[64];
    t30 = $[65];
  }
  let t31;
  if ($[66] !== tab) {
    t31 = <Tabs compact={true} m={t28} active_tab={tab} onTabSelected={t29} tabs={t30} />;
    $[66] = tab;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== organization || $[69] !== subscription || $[70] !== tab || $[71] !== trigger_attempt || $[72] !== trigger_event) {
    t32 = tab === "response" && <>{trigger_attempt.body ? <BodyCollapsibleSection body={trigger_attempt.body ?? {}} embedded={false} type="event" id={trigger_event.id} /> : <><Text muted={true} as="p">This attempt response is past your archival period of {subscription.retention_days}{" "}days, the request data is no longer available.</Text>{!organization && <Link to="/settings/organization/plans?highlight=retention_days" icon="upgrade">Upgrade plan</Link>}</>}</>;
    $[68] = organization;
    $[69] = subscription;
    $[70] = tab;
    $[71] = trigger_attempt;
    $[72] = trigger_event;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  let t33;
  if ($[74] !== organization || $[75] !== subscription || $[76] !== tab || $[77] !== trigger_event) {
    t33 = tab === "request" && <>{trigger_event.data ? <EventHTTPRequest event={trigger_event} embedded={false} hide_title={true} /> : <><Text muted={true} as="p">This event is past your archival period of {subscription.retention_days} days, the request data is no longer available.</Text>{!organization && <Link to="/settings/organization/plans?highlight=retention_days" icon="upgrade">Upgrade plan</Link>}</>}</>;
    $[74] = organization;
    $[75] = subscription;
    $[76] = tab;
    $[77] = trigger_event;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t11 || $[80] !== t26 || $[81] !== t31 || $[82] !== t32 || $[83] !== t33) {
    t34 = <>{t11}{t12}{t26}{t27}{t31}{t32}{t33}</>;
    $[79] = t11;
    $[80] = t26;
    $[81] = t31;
    $[82] = t32;
    $[83] = t33;
    $[84] = t34;
  } else {
    t34 = $[84];
  }
  return t34;
};
export default DeliveryIssue;
function _temp(status) {
  return `${status}`;
}